import { mapState } from 'vuex';
import { getWirelessBoxListServer } from '@/api/devices';
import ctt from '@/utils/const';

export default {
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  data() {
    return {
      deviceList: []
    };
  },

  mounted() {
    this.loadDeviceDataHandler();
  },
  methods: {
    loadDeviceDataHandler() {
      let deviceType = ctt.MN_606;
      getWirelessBoxListServer(deviceType)
        .then(res => {
          if (res.code == 200) {
            this.deviceList = res.data;
          }
        })
        .catch(err => {
          console.error('err', err);
        });
    }
  }
};
